<template>
   <el-drawer 
   v-model="payDialog.show" 
   :before-close="closePayDialog" 
   size="50%" 
   direction="btt" 
   custom-class="payment-order-drawer" 
   :show-close="false">
    <template #header>
      <div class="title">
        <h4>费用明细</h4>
        <div @click="copyDetails"><ab-svg name="my-fuzhi" class="issue"></ab-svg>复制</div>
      </div>
      <button
        aria-label="el.drawer.close"
        class="el-drawer__close-btn"
        type="button"
        style="color:#B2B2B2"
        @click="closeDrawer"
      >
        <i class="el-icon el-drawer__close">
          <el-icon :size="size" :color="color" >
            <CircleCloseFilled />
          </el-icon>
        </i>
      </button>
    </template>

    <template #default>
      <div class="serviceDetails">
        <div class="left">
          <h4></h4>
          <ul>
            <li>
              <span>订单金额（{{formData.coreBillCurrencyCode}}）</span>
              <div class="number">{{$filters.formatMoney(formData.coreBillAmount)}}</div>
            </li>
            <li>
              <span>{{ bizType === '01' ? '结算汇率' : '海关汇率' }}</span>
              <div class="number">{{ bizType === '01' ? formData.paySettleRate : formData.customsRate }}</div>
            </li>
            <li v-if="this.sourceType !== 'export'">
              <span>服务费率</span>
              <div class="number">{{formData.serviceRateStr}}</div>
            </li>
          </ul>
        </div>
        <div class="right">
          <ul>
            <template v-if="this.sourceType !== 'export'">
                <li>
                    <span>进口关税（CNY）</span>
                    <div class="number">{{$filters.formatMoney(formData.copeTariff)}}</div>
                </li>
                <li>
                    <span>进口增值税（CNY）</span>
                    <div class="number">{{$filters.formatMoney(formData.copeVat)}}</div>
                </li>
            </template>
            <li>
              <span>服务费（CNY）</span>
              <div class="number">{{$filters.formatMoney(formData.agencyFee)}}</div>
            </li>
            <li v-if="!formData.costExtrasEntry || !formData.costExtrasEntry.length">
              <span>杂费（CNY）</span>
              <div class="number">{{$filters.formatMoney(formData.extrasFee)}}</div>
            </li>
            <li v-for="(item, index) in formData.costExtrasEntry" :key="index">
              <span>{{item.feeName}}(CNY)</span>
              <div class="number">{{$filters.formatMoney(item.feeAmount)}}</div>
            </li>
            <li>
              <span>优惠券/余额抵扣（CNY）</span>
              <div class="number">{{formData.couponUseAmountShow || 0}}/ {{formData.accountUseAmountShow || 0}}</div>
            </li>
          </ul>
          <div class="rightMoney">合计（CNY）：<span class="number">{{ $filters.formatMoney(formData.realPay) }}</span></div>
        </div>
      </div>
      <el-divider style="border-top: 1px solid #f0f2f5; margin: 50px 0 0" />
    <textarea class="copy-text" id="copyText"></textarea>
    </template>
   
    <template #footer>
      <div style="flex: auto">
        <el-button @click="closeDrawer">取消</el-button>
        <el-button type="primary" @click="toPay" v-if="this.sourceType !== 'export'">去付款</el-button>
      </div>
    </template>
    
  </el-drawer>
</template>

<script>

export default {
  name: 'payment-dialog',

  props: {
    sourceType: {
      type: String
    }
  },

  data () {
    return {
      sourceData: {
        type: '',
        row: {}
      },
      payDialog: {
        show: false,
      },
      formData: {

      },
      bizType: '',
      dataForm: {}
    }
  },

  mounted () {
    
  },
  methods: {
    
    init(row) {
      let url = "/oms/client/entrustImport/get"
      if (this.sourceType && this.sourceType == 'export') {
        url = "/oms/client/entrustExport/get"
      }
      this.$get(url, { id: row.id }).then(res => {
        if (res.data && res.data.code === "C0000") {
          this.dataForm = res.data.result
          this.formData = this.dataForm.costEstimate || {}
          this.bizType = this.dataForm.bizType
          this.payDialog.show = true
        }
      })
      
      
    },
    closeDrawer () {
      this.payDialog.show = false
    },
    toPay() {
      if (this.sourceType && this.sourceType == 'export') {
        this.$router.push('/pledging-payment-list')
      } else {
        this.$router.push('/payable-list')
      }
      this.closeDrawer()
    },
    copyDetails () {
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      let infoText = `订单金额 (${this.formData.coreBillCurrencyCode}): ${this.formData.coreBillAmount}\n` +
      `${this.bizType === '01' ? '结算汇率' : '海关汇率'}: ${this.bizType === '01' ? this.formData.paySettleRate : this.formData.customsRate}\n` +
      `服务费率: ${this.formData.serviceRateStr}\n` +
      `进口关税（￥）: ${this.formData.copeTariff}\n` + 
      `进口增值税（￥）: ${this.formData.copeVat}\n` +
      `服务费（￥）: ${this.formData.agencyFee}\n`;
      if (!this.formData.costExtrasEntry || !this.formData.costExtrasEntry.length) {
        infoText += `杂费（￥）: ${this.formData.extrasFee}\n`
      }
      if (this.formData.costExtrasEntry && this.formData.costExtrasEntry.length) {
        this.formData.costExtrasEntry.map(e => {
          infoText += `${e.feeName}: ${e.feeAmount}\n`;
        })
      }
      infoText += `优惠券/余额抵扣: ￥${this.formData.couponUseAmountShow || 0}/ ￥${this.formData.accountUseAmountShow || 0}\n` +
      `合计（CNY）: ${this.formData.realPay}\n`;
      input.value = infoText
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    }
  }
}
</script>

<style lang="scss">
.payment-order-drawer {
  text-align: left;
  color: #000000;
  border-radius: 16px;
  .el-drawer__header {
    font-size: 18px;
    color: #000000;
    /*  width: 70%;
    margin: 0 auto; */
    //   width: 100%;
    width: 100%;
    padding: 20px 15% 0 15%;
    .title {
      display: flex;
      justify-content: space-between;
      h4 {
        font-size: 18px;
      }
      div {
        cursor: pointer;
        margin-right: 40px;
        font-size: 16px;
        .icon-svg {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 6px;
        }
      }
    }
  }
  .el-drawer__body {
    width: 100%;
    padding: 20px 15% 0 15%;
    padding-bottom: 0;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #aaa;
      &:hover {
          background: #999;
      }
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    .el-alert {
      background-color: #feeae3;
      color: #f87243;
      margin-top: 30px;
      span {
        font-size: 14px;
      }
    }
    .paymentDetails {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      .left {
        width: 50%;
        display: flex;
        h4 {
          font-size: 16px;
          width: 100px;
        }
        li {
          font-size: 14px;
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 125px;
          }
          div {
            display: inline-block;
            width: 100px;
            text-align: right;
            font-size: 18px;
            font-weight: 500;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
      .right {
        width: 50%;
        font-size: 14px;
        padding: 43px 0 0 40px;
        span {
          font-size: 48px;
          color: #f87243;
          font-weight: 500;
          margin-left: 50px;
        }
      }
    }

    .serviceDetails {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      .left {
        width: 50%;
        display: flex;
        h4 {
          font-size: 16px;
          width: 100px;
        }
        li {
          font-size: 14px;
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 125px;
          }
          div {
            display: inline-block;
            width: 100px;
            text-align: right;
            font-size: 18px;
            font-weight: 500;
          }
        }
      }
      .right {
        width: 50%;
        padding-left: 40px;
        li {
          display: flex;
          font-size: 14px;
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 128px;
          }
          div {
            display: inline-block;
            width: 110px;
            text-align: right;
            font-size: 18px;
            font-weight: 500;
          }
          &:last-child {
            margin: 0;
          }
        }
        .rightMoney {
          font-size: 14px;
          span {
            font-weight: 500;
            color: #f87243;
            font-size: 48px;
            margin-left: 50px;
          }
        }
      }
    }
    .serviceDetails-1 {
      width: 1000px;
      margin: 0 auto;
      h4 {
        font-size: 16px;
        font-weight: 400;
      }
      .banner {
        text-align: center;
        img {
          width: 120px;
          height: 120px;
          vertical-align: middle;
        }
        div {
          font-weight: 400;
          color: #f87243;
          font-size: 16px;
          img {
            width: 68px;
            height: 68px;
          }
        }
        p {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }

    .goodsMoney {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      h4,
      div {
        width: 50%;
      }
      h4 {
        font-size: 16px;
      }
      div {
        padding-left: 187px;
        font-size: 48px;
        font-weight: 500;
        color: #f87243;
      }
    }
    .collection {
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
        h4 {
          font-size: 18px;
        }
        div {
          cursor: pointer;
          margin-right: 55px;
          font-size: 16px;
          .icon-svg {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 6px;
          }
        }
      }
      .banner {
        width: 1000px;
        display: flex;
        margin: 0 auto;
        ul {
          width: 50%;
        }
        li {
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 100px;
            font-size: 16px;
          }
          div {
            display: inline-block;
            font-size: 18px;
            font-weight: 500;
          }
          &:last-child {
            margin: 0;
          }
        }
        .right {
          padding-left: 40px;
          div {
            font-weight: 500;
          }
        }
      }
    }
  }
  .el-drawer__footer {
    text-align: center;
  }
}
</style>
